import React, { useEffect } from "react";
import { CenteredSpin } from "web/src/components/chrome/CenteredSpin";
import { DocsInterface } from "../chrome/DocsInterface";
import { useDocsLocation } from "../chrome/nav/useDocsLocation";
import { DocsRedirects } from "../redirects";

const Redirect = (props: any) => {
  const [location, setLocation] = useDocsLocation();

  useEffect(() => {
    const [path] = location.split("#", 2);
    const destination = props.redirectTo ?? DocsRedirects[path];
    if (destination) {
      const target = new URL(destination, window.location.origin);
      if (!target.hash) target.hash = window.location.hash;
      if (destination.startsWith("http")) {
        window.location.replace(target.href);
      } else {
        setLocation(target.pathname + target.search + target.hash, { replace: true });
      }
    } else {
      setLocation("/", { replace: true });
    }
  }, [location, props.redirectTo, setLocation]);

  return (
    <DocsInterface {...props}>
      <CenteredSpin />
    </DocsInterface>
  );
};

export default Redirect;
